import type { PaletteOptions } from '@mui/material'

export const palette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#1a4cd8',
    light: '#3d7aff',
    dark: '#0033a0',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#c9b107',
    light: '#d4c020',
    dark: '#9a8505',
    contrastText: '#000000',
  },
  error: {
    main: '#ef4444',
    light: '#f87171',
    dark: '#dc2626',
  },
  warning: {
    main: '#f59e0b',
    light: '#fbbf24',
    dark: '#d97706',
  },
  info: {
    main: '#3d7aff',
    light: '#60a5fa',
    dark: '#1a4cd8',
  },
  success: {
    main: '#22c55e',
    light: '#4ade80',
    dark: '#16a34a',
  },
  background: {
    default: '#050510',
    paper: '#12121f',
  },
  divider: '#2a2a45',
  text: {
    primary: '#f0f0f5',
    secondary: '#a0a5b5',
    disabled: '#6b7280',
  },
}
